import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import { useDateLocale } from "../../i18n/use-date-locale";
import { builderSampleWeek } from "../../lib/metadata-builder/sample-schedule";
import { weekdayKeys } from "../../lib/schedule-time/schedule-dates";
import { endMetadataMerge } from "../../lib/metadata-history/dispatch";
import { useMetadataBuilderStore } from "../../stores/metadata-builder-store";
import { useMetadataEditingStore } from "../../stores/metadata-editing-store";
import { cn } from "../../lib/utils";
import { builderDayLayoutMode } from "../../lib/metadata-builder/day-layouts";
import { metadataTargets } from "../../lib/metadata-history/metadata-targets";
import { getCanvasState } from "../../lib/schedule-art/canvas-state";
import type { MetadataDay } from "../../lib/metadata-history/metadata-targets";

function selectDayElement(day: MetadataDay, mode: "offline" | "one_slot" | "two_slot") {
  const state = getCanvasState();
  const metadata = state.canvasMetadata ?? state.preset.metadata;
  const selected = useMetadataEditingStore.getState().selected;
  const current = metadataTargets(metadata).find(target => target.path === selected);
  if (current?.bind === "origin") return `days.${day}.origin`;
  if (current?.bind === "day.date") return `days.${day}.date`;
  const index = metadata.days[day][mode].findIndex(element => element.bind === current?.bind);
  return `days.${day}.${mode}.${index >= 0 ? index : 0}`;
}

export function DayPreviewControls() {
  const { t } = useTranslation();
  const sampleDate = useMetadataBuilderStore(state => state.sampleDate);
  const week = builderSampleWeek(sampleDate);
  const locale = useDateLocale();
  const selectedDay = useMetadataBuilderStore(state => state.selectedDay);
  const previewDay = useMetadataBuilderStore(state => state.previewDay);
  const setSelectedDay = useMetadataBuilderStore(state => state.setSelectedDay);
  const setPreviewDay = useMetadataBuilderStore(state => state.setPreviewDay);
  const step = useMetadataBuilderStore(state => state.step);
  const mode = builderDayLayoutMode(step) ?? "offline";
  return (
    <div className="flex flex-wrap gap-1">
      {weekdayKeys.map((day, index) => <button key={day} type="button"
        className={cn("rounded border px-2 py-1.5", selectedDay === day ? "border-neutral-900 bg-neutral-900 text-white" : "border-neutral-200 hover:bg-neutral-50")}
        onClick={() => {
          endMetadataMerge();
          const path = selectDayElement(day, mode);
          setSelectedDay(day);
          useMetadataEditingStore.getState().select(path);
        }}>
        {format(week[index]!, "EEE", { locale })}
      </button>)}
      <button type="button" className={cn("rounded border px-2 py-1.5", !previewDay ? "border-sky-600 bg-sky-50 text-sky-800" : "border-neutral-200 hover:bg-neutral-50")}
        onClick={() => { endMetadataMerge(); setPreviewDay(null); }}>
        {t("builder.days.fullWeek")}
      </button>
    </div>
  );
}
